import { IsAuthenticationEnabled } from "../../Model/AuthenticationSetting";
import { FetchStatus } from "../../Model/FetchStatus";
import { AuthenticationSettingAction, EAuthenticationAction } from "../actions/AuthenticationSettingAction";
import { RootState } from "./RootReducer";


type State = {
	status: FetchStatus;
	enableAuthenticationSetting: IsAuthenticationEnabled;
	enableSupportMode: boolean;
};
const initialState: State = {
	enableAuthenticationSetting: {
		enable: false,
	},
	enableSupportMode: false,
	status: {
		pending: false,
		completed: false,
		error: null,
	},
}


export function authenticationSettingReducer(state = initialState, action: AuthenticationSettingAction): State {
	switch (action.type) {
		case EAuthenticationAction.AUTHENTICATION_ENABLE_SUCCESS: {
			return {
				...state,
				enableAuthenticationSetting: action.authenticationEnable,
				status: {
					pending: false,
					completed: true,
					error: null,
				},
			}
		}
		case EAuthenticationAction.AUTHENTICATION_ENABLE_PENDING: {
			return {
				...state,
				enableAuthenticationSetting: {
					enable: false
				},
				status: {
					pending: true,
					completed: false,
					error: null,
				},

			}
		}
		case EAuthenticationAction.AUTHENTICATION_ENABLE_ERROR: {
			return {
				...state,
				enableAuthenticationSetting: {
					enable: false
				},
				status: {
					pending: false,
					completed: true,
					error: action.error,
				},
			}
		}
		case EAuthenticationAction.AUTHENTICATION_SET_SUPPORT_MODE: {
			return {
				...state,
				enableSupportMode: action.enableSupportMode,
			}
		}
		case EAuthenticationAction.REDIRECT_TO_LOGIN_PAGE: {
			if (state.enableAuthenticationSetting.enable)
				window.location.href = "/login";
			return state;
		}
		default:
			return state;
	}
}


export const isSupportModeEnabled = (state: RootState): boolean => state.authenticationSettingStore.enableSupportMode;
export const isAuthenticationEnable = (state: RootState): boolean => state.authenticationSettingStore.enableAuthenticationSetting.enable;
export const getIsAuthenticationEnableFetchStatus = (state: RootState): FetchStatus => state.authenticationSettingStore.status;
